export const UPDATE_NOTIFICATION_SETTINGS = 'UPDATE_NOTIFICATION_SETTINGS';
export const UPDATE_TYPE_SETTINGS = 'UPDATE_TYPE_SETTINGS';
export const UPDATE_EMAIL_SETTINGS = 'UPDATE_EMAIL_SETTINGS';
